import PageLayout from '../components/global/PageLayout';
import NotificationsSettings from '../components/notifications/NotificationsSettings';

export default function NotificationsPage() {
  return (
    <PageLayout>
      <NotificationsSettings />
    </PageLayout>
  );
}
